var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.163,
    height: 22.163,
    viewBox: "0 0 22.163 22.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cross",
    transform: "translate(-747.529 -281.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M754.915,296.7a10.582,10.582,0,0,1,13.319,14.314,10.49,10.49,0,0,1-1.043,1.793,10.576,10.576,0,0,1-12.979,3.432,10.593,10.593,0,0,1-3.348-2.415,10.584,10.584,0,0,1,4.051-17.124Z",
    transform: "translate(0 -14)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_301",
    "data-name": "Line 301",
    x2: 8.304,
    y2: 8.304,
    transform: "translate(754.484 288.473)",
    fill: "none",
    stroke: "#ff1a00",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_302",
    "data-name": "Line 302",
    y1: 8.304,
    x2: 8.304,
    transform: "translate(754.484 288.473)",
    fill: "none",
    stroke: "#ff1a00",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/Red-cross.0ddf5f7ba47f9224855353c6de8367b6.svg";
export { ForwardRef as ReactComponent };